<template>
  <div id="app">
    <v-head v-if="headerShow"></v-head>
    <v-left v-if="leftShow"></v-left>
    <router-view style="min-height:500px;"/>
    <v-foot v-if="footerShow"></v-foot>
  </div>
</template>

<script>
import head from "@/pages/public/_head";
import foot from "@/pages/public/_foot";
import left from "@/pages/public/_left";
export default {
  name: 'App',
  components: {
    "v-head": head,
    "v-foot": foot,
    "v-left": left,
  },
  data() { 
    return {
      headerShow: false,
      footerShow: false,
      leftShow: false,
    }
  },
  watch: {
      '$route'(newRoute) {
          this.headerShow = newRoute.meta && newRoute.meta.headerShow;
          this.footerShow = newRoute.meta && newRoute.meta.footerShow;
          this.leftShow = newRoute.meta && newRoute.meta.leftShow;
      }
  }
}
</script>
<style>
  @import './assets/css/global.css';
</style>



// WEBPACK FOOTER //
// src/App.vue